// Add code here to update variables for dyanmic AccessKey, Div Name, Language code and selection type.

//General:
var WidgetProfileId = 1;
var Region = "use";
var LanguageCode = getLang();

//UAT
//var LicenseKey = "7818DA97-EDAF-4F97-9A08-7E365E12EAE3";
//var Environment = "UAT";

//Production
var LicenseKey = "D0A47C10-5DA3-412D-9232-B6073B69BD3D";
var Environment = "production";


var cassieSettings = {
  widgetProfileId: WidgetProfileId,
  languageCode: LanguageCode,
  licenseKey: LicenseKey,
  region: Region,
  environment: Environment,
  crossDomainConsent: false
};
window.CassieWidgetLoader = new CassieWidgetLoaderModule(cassieSettings);
console.log("Cassie files loaded.");

/*
var isrc = document.getElementById("prefiFrame");
  isrc.setAttribute("src", "https://trustcassie.com/?");
*/

// Add these functions optionally in the event you want to setCookies in script without restating the functions
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Update Cookie Settings to launch the showModal method since the footer cannot accept custom code.
window.addEventListener("load", function () {
  var cky = document.querySelectorAll("a[href*='#cookie']");
  for (let i = 0; i < cky.length; i++) {
    cky[i].setAttribute("onclick", "event.preventDefault(); CassieWidgetLoader.Widget.showModal();");
}});

// Get the language code to drive cookie banner, preference links and preference widgets. Look for /fr at the end of the URL.
function getLang() {
  // Check if URL ends with "/fr" (case-insensitive)
  const url = window.location.href.toLowerCase(); // Get full URL and convert to lowercase
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent);
  
  if (url.endsWith("/fr") || url.includes("/fr")) {
    console.log("Detected language = fr-CA");
    return "fr-CA"; // Or your desired language code for "/fr" URLs
  } else {
    console.log("Detected language = Default");
    return ""; // Or your default language code
  }
}
